import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Rma, initialRma } from "./Rma";
import TaskGridLookup from "../../Components/Lookup/Lookup";
import { ChangeData } from "../../utils/Change/changeTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { initialTask, Task } from "../Task/Task";
import FileUploader from "../../Components/FileUpload/FileUpload";
import TextArea from "../../Components/TextArea/TextArea";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { authFetch } from "../../utils/Security/authFetch";
import { handleEdit } from "../../utils/Rma/rmaHandlers";

type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
function RmaEdit() {
  const [rma, setRma] = useState<Rma>(initialRma);
  const navigate = useNavigate();
  const organization = localStorage.getItem("organization") || undefined;
  const isForNilesat = localStorage.getItem("isForNilesat") === "true";

  const [journalMessages, setJournalMessages] = useState<Message[]>([]);
  const [originalRma, setOriginalRma] = useState<Rma | null>(null);

  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [task, setTask] = useState<Task>(initialTask);
  const { id } = useParams();
  const [emails, setEmails] = useState<[]>();
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);

  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | undefined
  >(undefined);

  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | RmaData
      | IncidentData
    )[]
  >([]);
  useEffect(() => {
    if (id) {
      authFetch(`${config.apiBaseUrl}/api/rmas/${id}`)
        .then((res) => res.json())
        .then((data) => {
          console.log("rma data>>>>>>", data);
          setRma(data);
          setOriginalRma(data); // keep a copy for comparison
        })
        .catch((err) => console.error("Failed to fetch rma:", err));
    }
  }, [id]);
  useEffect(() => {
    setCustomer(rma.affectedCustomer);
  }, [rma.affectedCustomer]);
  useEffect(() => {
    if (isForNilesat) {
      const fetchNilesatData = async () => {
        try {
          const responseIds = await authFetch(
            `${config.apiBaseUrl}/api/users/id-by-organization?organization=Nilesat`
          );
          if (!responseIds.ok) throw new Error("Failed");

          const userIds = await responseIds.json();
          const userIdsParam = Array.isArray(userIds)
            ? userIds.join(",")
            : userIds;

          const responseEmails = await authFetch(
            `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
          );
          const emails = await responseEmails.json();
          setEmails(emails);

          handleDataChange("foruserid", userIds);
          handleDataChange("affectedCustomer", ["Nilesat"]);
          setCustomer(["Nilesat"]);
        } catch (error) {
          console.error("Failed to fetch Nilesat customer or emails:", error);
        }
      };

      fetchNilesatData();
    }
  }, [isForNilesat, rma.ticketId]);
  useFetchFullName((fullName: string) => {
    setRma((prev) => ({ ...prev, user: fullName }));
  });
  const handleCancel = () => {
    navigate("/rma request");
  };

  const handleDataChange = (field: keyof Rma, value: any) => {
    setRma((prev) => ({ ...prev, [field]: value }));
  };
  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId); // collect all selected ticketIds
    handleDataChange("relatedobject", ticketIds); // now this should be an array
    setSelectedTask(tasks); // you might rename this to selectedTasks now
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const updatedRma: Rma = {
      ...rma,
      affectedSite:
        localStorage.getItem("isAllSite") === "true"
          ? ["All Sites"]
          : rma.affectedSite,
      affectedLink:
        localStorage.getItem("isAllLink") === "true"
          ? ["All Links"]
          : rma.affectedLink,
      affectedNetwork:
        localStorage.getItem("isAllNetwork") === "true"
          ? ["All Networks"]
          : rma.affectedNetwork,
    };

    const relatedObjectChanged =
      JSON.stringify(originalRma?.trackstage ?? []) !==
      JSON.stringify(updatedRma.trackstage ?? []);
    authFetch(`${config.apiBaseUrl}/api/rmas/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedRma),
    })
      .then((res) => res.json())
      .then(async (data) => {
        const fetchMessages = async () => {
          if (!data?.ticketId) return;
          const res = await authFetch(
            `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
          );
          if (res.ok) setJournalMessages(await res.json());
        };
        await handleEdit(data, navigate, fetchMessages, relatedObjectChanged);
        navigate("/rma-request");
      })
      .catch((err) => console.error("Failed to update rma:", err));
  };

  return (
    <div className="rma-form">
      <section className="form-section">
        <h3>Rma Information</h3>
        <div className="grid">
          <Input
            type="text"
            label="Created By"
            value={rma.createdby ?? ""}
            onChange={(val) => handleDataChange("createdby", val)}
            readOnly
          />
          <ApiDropdown
            api="users"
            labelKey="username"
            valueKey="id"
            value={rma.userid}
            label="User"
            onChange={async (val) => {
              handleDataChange("userid", val);
              try {
                const res = await authFetch(
                  `${config.apiBaseUrl}/api/users/${val}`
                );
                if (!res.ok) throw new Error("User not found");
                const user = await res.json();
                handleDataChange("email", user.email);
              } catch (err) {
                console.error("Error fetching user:", err);
              }
            }}
          />

          <Input
            readOnly
            type="text"
            label="Ticket ID"
            value={rma.ticketId || ""}
            onChange={() => {}}
          />
          {isAdmin && (
            <Input
              type="text"
              label="Vendor RMA cross reference number"
              value={rma.vendorrmacross}
              onChange={(val) => handleDataChange("vendorrmacross", val)}
            />
          )}
          {!isAdmin &&  (
            <ApiDropdown
              api="track"
              labelKey="name"
              valueKey="name"
              disabled
              value={rma.trackstage}
              label="Track Stage"
              onChange={(val) => handleDataChange("trackstage", val)}
            />
          )}
 
          {isAdmin && (
            <ApiDropdown
              api="track"
              labelKey="name"
              valueKey="name"
              value={rma.trackstage}
              label="Track Stage"
              onChange={(val) => handleDataChange("trackstage", val)}
            />
          )}
        </div>
      </section>

      <section className="form-section">
        <h3>Customer Contact Information</h3>
        <div className="grid">
          {!isAdmin && !isForNilesat && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              value={organization}
              valueKey="customername"
              label="Customer"
              disabled
              isMulti
              onOpen={async () => {
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  handleDataChange("foruserid", userIds);
                  handleDataChange("affectedCustomer", [organization]);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
       {isAdmin && isForNilesat && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              valueKey="customername"
              label="Customer"
              value={"Nilesat"}
              disabled
            />
          )}
          {isAdmin && !isForNilesat && (
            <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              valueKey="customername"
              label="Customer"
              value={customer}
              isMulti
              onChange={async (val) => {
                setCustomer(val);
                try {
                  const responseIds = await authFetch(
                    `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                  );
                  if (!responseIds.ok)
                    throw new Error(
                      `HTTP error! status: ${responseIds.status}`
                    );
                  const userIds = await responseIds.json();
                  const userIdsParam = Array.isArray(userIds)
                    ? userIds.join(",")
                    : userIds;
                  const responseEmails = await authFetch(
                    `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                  );
                  if (!responseEmails.ok)
                    throw new Error(
                      `HTTP error! status: ${responseEmails.status}`
                    );
                  const emails = await responseEmails.json();
                  setEmails(emails);
                  handleDataChange("foruserid", userIds);
                  handleDataChange("affectedCustomer", val);
                } catch (error) {
                  console.error("Failed to fetch customer or emails:", error);
                }
              }}
            />
          )}
          {!isAdmin && organization && (
            <ApiDropdown
              api={`everything/networks?customer=${organization}`}
              labelKey="label"
              valueKey="value"
              label="Networks"
              value={rma.affectedNetwork}
              isMulti
              onChange={(val) => {
                setNetwork(val);
                handleDataChange("affectedNetwork", val);
              }}
            />
          )}

          {!isAdmin && organization && (
            <>
              {(network || rma.affectedNetwork) && (
                <ApiDropdown
                  api={`everything/sites?customer=${organization}&network=${
                    network || rma.affectedNetwork
                  }`}
                  labelKey="label"
                  valueKey="value"
                  label="Site"
                  value={rma.affectedSite}
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleDataChange("affectedSite", val);
                  }}
                />
              )}
            </>
          )}

          {isAdmin && (
            <>
              {(customer || rma.affectedCustomer) && (
                <ApiDropdown
                  api={`everything/networks?customer=${
                    customer || rma.affectedCustomer
                  }`}
                  labelKey="label"
                  valueKey="value"
                  label="Networks"
                  value={rma.affectedNetwork}
                  isMulti
                  onChange={(val) => {
                    setNetwork(val);
                    handleDataChange("affectedNetwork", val);
                  }}
                />
              )}

              {(network || rma.affectedNetwork) && (
                <ApiDropdown
                  api={`everything/sites?customer=${
                    customer || rma.affectedCustomer
                  }&network=${network || rma.affectedNetwork}`}
                  labelKey="label"
                  valueKey="value"
                  value={rma.affectedSite || ""}
                  label="Site"
                  isMulti
                  onChange={(val) => {
                    setSite(val);
                    handleDataChange("affectedSite", val);
                  }}
                />
              )}
            </>
          )}
          <Input
            type="text"
            label="Customer name "
            value={rma.customername}
            onChange={(val) => handleDataChange("customername", val)}
          />
          <Input
            type="text"
            label="Point Of Contact "
            value={rma.pointofcontact}
            onChange={(val) => handleDataChange("pointofcontact", val)}
          />
        </div>
      </section>

      <section className="form-section">
        <h3>Device Information</h3>
        <div className="grid">
          <Input
            type="text"
            label="Brand"
            value={rma.brand}
            onChange={(val) => handleDataChange("brand", val)}
          />
          <Input
            type="text"
            label="Model No"
            value={rma.model}
            onChange={(val) => handleDataChange("model", val)}
          />

          <Input
            type="text"
            label="Part Number"
            value={rma.partnumber}
            required
            onChange={(val) => handleDataChange("partnumber", val)}
          />
          <Input
            type="text"
            label="Serial Number"
            required
            value={rma.serialnumber}
            onChange={(val) => handleDataChange("serialnumber", val)}
          />
          <Input
            type="text"
            label="Password (Optional)"
            value={rma.password}
            onChange={(val) => handleDataChange("password", val)}
          />
          <ApiDropdown
            api="yesno"
            labelKey="name"
            valueKey="name"
            value={rma.activewarranty}
            label="Active Warranty Yes/No"
            onChange={(val) => handleDataChange("activewarranty", val)}
          />
          <div className="grid-full-width">
            <TextArea
              style={{ width: "100%" }}
              label="Fault Description /Analysis /Troubleshooting"
              value={rma.faultdescription}
              onChange={(val) => handleDataChange("faultdescription", val)}
            />
            <TextArea
              label="Solution"
              style={{ width: "100%" }}
              value={rma.solution}
              onChange={(val) => handleDataChange("solution", val)}
            />
          </div>
        </div>
      </section>

      <section className="form-section">
        <h3>Information</h3>
        <div className="grid">
          <>
            <ApiDropdown
              api="yesno"
              labelKey="name"
              valueKey="name"
              value={rma.ior}
              label="Is the customer the Importer of Record (IoR)?"
              onChange={(val) => handleDataChange("ior", val)}
            />
            <Input
              type="text"
              label="Company name"
              value={rma.companyname}
              onChange={(val) => handleDataChange("companyname", val)}
            />{" "}
            <Input
              type="text"
              label="City "
              value={rma.city}
              onChange={(val) => handleDataChange("city", val)}
            />
            <Input
              type="text"
              label="Name"
              value={rma.name}
              onChange={(val) => handleDataChange("name", val)}
            />
            <Input
              type="text"
              label="Region "
              value={rma.region}
              onChange={(val) => handleDataChange("region", val)}
            />
            <Input
              type="text"
              label="Email"
              value={rma.email}
              onChange={(val) => handleDataChange("email", val)}
            />
            <Input
              type="text"
              label="Country "
              value={rma.country}
              onChange={(val) => handleDataChange("country", val)}
            />
            <Input
              type="text"
              label="Phone Number"
              value={rma.phonenumber}
              onChange={(val) => handleDataChange("phonenumber", val)}
            />
            <Input
              type="text"
              label="Zip Code "
              value={rma.zip}
              onChange={(val) => handleDataChange("zip", val)}
            />
            <Input
              type="text"
              label="Address Line 1 "
              value={rma.address1}
              onChange={(val) => handleDataChange("address1", val)}
            />
            <Input
              type="text"
              label="Address Line 2 "
              value={rma.address2}
              onChange={(val) => handleDataChange("address2", val)}
            />
          </>
        </div>
      </section>
      {/* <section className="form-section">
        <h3>SLA & OLA</h3>
        <div className="grid">
          {isAdmin && (
            <>
              <Input
                type="text"
                label="OLA"
                value={rma.ola}
                onChange={(val) => handleDataChange("ola", val)}
              />
              <Input
                type="text"
                label="OLA Status"
                value={rma.olaStatus}
                onChange={(val) => handleDataChange("olaStatus", val)}
              />
            </>
          )}
        </div>
      </section> */}
      <section className="form-section">
        <h3>Related object</h3>
        <div className="grid">
          <></>
          <FileUploader
            value={rma.filePath}
            onRemove={(path) =>
              handleDataChange("filePath", (rma.filePath || []).filter((p: any) => p !== path))
            }
            onChange={async (files, paths) => {
              if (!files || !paths.length) return;
              const uploadedPaths: string[] = [];
              for (let i = 0; i < files.length; i++) {
                const formData = new FormData();
                formData.append("file", files[i]);
                try {
                  const response = await authFetch(
                    `${config.apiBaseUrl}/api/rmas/upload`,
                    {
                      method: "POST",
                      body: formData,
                    }
                  );
                  if (response.ok) {
                    const { path } = await response.json();
                    uploadedPaths.push(path);
                  } else {
                    console.error(`Upload failed for file: ${files[i].name}`);
                  }
                } catch (error) {
                  console.error("Error uploading file", error);
                }
              }
              if (uploadedPaths.length) {
                handleDataChange("filePath", [
                  ...(rma.filePath || []),
                  ...uploadedPaths,
                ]);
              }
            }}
          />
          {isAdmin && (
            <Input
              readOnly
              type="text"
              label="Related Object"
              value={rma.relatedobject || ""}
              onChange={(val) => handleDataChange("relatedobject", val)}
            />
          )}
          {isAdmin && (
            <button type="button" onClick={handleOpenTaskLookup}>
              Select Related Ticket
            </button>
          )}
          {selectedTask && selectedTask.length > 0 && (
            <div>
              <p>
                <strong>Selected Tasks:</strong>
              </p>
              <ul>
                {selectedTask.map((task, index) => (
                  <li key={index}>{task.ticketId}</li>
                ))}
              </ul>
            </div>
          )}
          <TaskGridLookup
            isOpen={isTaskLookupOpen}
            onClose={handleCloseTaskLookup}
            selectedItems={selectedTask}
            onSelect={handleTaskSelect}
          />
        </div>
      </section>
      <div className="submit-section">
        <button onClick={handleSubmit}>Submit RMA</button>
        <button type="button" onClick={handleCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default RmaEdit;
